import { Fragment } from 'react';
import { useModel } from '../../hooks/use-model';

export const Content = () => {
	const modelComponents = useModel();

	return (
		<Fragment>
			{modelComponents.map((component, index) => (
				<Fragment key={index}>{component}</Fragment>
			))}
		</Fragment>
	);
};
